import React from 'react';
import styled from 'styled-components';
import BaseSelect from '../Select';
import { I18n } from 'react-redux-i18n';

const ChartInputsBlocContainer = styled.div`
  .row {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    white-space: nowrap;
  }

  @media (max-width: 1350px) {
    position: initial;
    margin-top: 20px;

    .row {
      flex-direction: column;
    }
    .subRow {
      flex-direction: column;
    }

    .bigSelect {
      min-width: 150px;
      width: 150px;
    }
    .bigSelect > div {
      min-width: 150px;
      width: 150px;
    }
  }

  .label {
    font-family: ${(props) => props.theme.fonts.sfcompact_text};
    font-size: 12px;
    margin-right: 15px;
    margin-bottom: 0px;
  }

  .row > *:not(:last-child) {
    margin-right: 10px;
  }

  .subRow {
    display: flex;
    flex-direction: row;
    align-items: center;
  }

  .chartInputRadioContainer {
    margin-right: 20px;
    display: flex;
    flex-direction: row;
    align-items: center;
  }

  .chartInputRadioContainer div {
    display: flex;
  }

  .wineInputContainer {
    display: flex;
    flex-direction: row;
    align-items: center;
  }
`;

const SeparatorYear = styled.div`
  margin: 0 5px;
`;

const Select = ({
  value,
  options,
  onChange,
  minWidth,
  width,
  placeholder,
  className
}) => (
  <BaseSelect
    className={className}
    value={value}
    minWidth={minWidth}
    options={options}
    onChange={onChange}
    placeholder={placeholder}
    customStyles={{
      control: {
        height: '40px',
        minHeight: '40px',
        width: width,
        minWidth: width,
        padding: 0
      },
      container: {
        width: width,
        minWidth: width,
        height: 40,
        padding: 0
      },
      valueContainer: {
        height: '40px !important',
        padding: 0
      }
    }}
    dropdownProps={{
      styles: `margin-left:-25px`,
      colorIcon: '#e25d34 '
    }}
  />
);

const ChartInputsBloc = ({
  wine,
  vintageStart,
  vintageEnd,
  wineOptions,
  vintageOptions,
  onChange,
  noVintageEnd
}) => (
  <ChartInputsBlocContainer>
    <div className="row">
      {wineOptions && (
        <div className="subRow">
          <div className="wineInputContainer">
            <p className="label">Vin :</p>
            <Select
              className="bigSelect"
              value={wine}
              options={wineOptions}
              onChange={(selectedOption) => onChange('wine', selectedOption)}
              placeholder="Vin"
              width="150px"
            />
          </div>
        </div>
      )}
      <div className="subRow">
        <p className="label">{I18n.t('vintageChoice')}</p>
        <Select
          value={vintageStart}
          options={vintageOptions}
          onChange={(selectedOption) =>
            onChange('vintageStart', selectedOption)
          }
          placeholder={I18n.t('placeholderAll')}
          minWidth="50px"
          width="80px"
        />
        {!noVintageEnd && (
          <React.Fragment>
            <SeparatorYear>-</SeparatorYear>
            <Select
              value={vintageEnd}
              options={vintageOptions}
              onChange={(selectedOption) =>
                onChange('vintageEnd', selectedOption)
              }
              placeholder={I18n.t('placeholderAll')}
              minWidth="50px"
              width="80px"
            />
          </React.Fragment>
        )}
      </div>
    </div>
  </ChartInputsBlocContainer>
);

export default ChartInputsBloc;
